import { ImagineRelationship } from '@leverege/molten-core';
export default class RsrcRelationship extends ImagineRelationship {
  constructor(options, calc) {
    const {
      blueprint: bp,
      attribute: att
    } = options;
    super({
      apiName: 'imagineRsrc',
      relationshipType: att ? att.relationshipType : 'oneToMany',
      objectType: bp.type,
      ...options
    }, calc);
  }
  createItem(match, path) {
    if (this.isAlias) {
      return this.createResolved(match);
    }
    const isGroup = this.isGroup;
    const key = this.options.idKey;
    const id = isGroup ? path || match?.params?.[key] : this.subpath;
    const calc = {};
    if (match) {
      if (path && isGroup) {
        calc.match = {
          ...match,
          params: {
            ...match.params,
            [key]: path
          }
        };
      } else {
        calc.match = {
          ...match
        };
      }
      if (id) {
        calc.id = id;
      }
    }
    if (this.isItem) {
      // Rebind to a new match context
      return new this.constructor(this.options, calc);
    }
    const refPath = this.refPath;
    let urlPath = this.urlPath;
    if (isGroup) {
      // We are a group, which uses keys. Add that to the url and ref path
      urlPath = `${urlPath}/:${key}`;
    }
    const opts = {
      ...this.options,
      parent: this,
      isItem: true,
      urlPath,
      refPath
    };
    const itemRel = new this.constructor(opts, calc);
    return itemRel;
  }
}